import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { timeFormatToRegex } from '@optical/utils';

export function timeValidator(format: string): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    if (!control.value) {
      return null; // No validation error if the input is empty
    }

    if (!timeFormatToRegex(format).test(control.value)) {
      return { time: 'app.invalidTimeFormat' };
    }

    return null; // Validation passed
  };
}
